module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"row\"> <div class=\"col-md-10 col-lg-8\"> <div> <div id=\"api_mode_toggle\" class=\"filter-selector\"></div> <div id=\"object_type_selector\" class=\"filter-selector\"></div> </div> <div id=\"report_search\"></div> <div id=\"report_list\"></div> <div id=\"report_pagination\"></div> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/reports/template.ejs
// module id = 811
// module chunks = 1